// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__npSfE","left":"styles_left__2FhUB","desktopActions":"styles_desktopActions__1nmJJ","title":"styles_title__3q_Xj"};